export class MentionRequest {
   userId: number;

   constructor() {
      this.userId = 0;
   }
}
